import Joi from 'joi';
import PropTypes from 'prop-types';

import Conditional from '../../common/conditional';
import Form from '../../common/form';

import { getFileUploadTypes, matchPhrases } from '../../../utils/utilities';
import { IMAGE_LIMITS } from '../../../utils/constants';
import { getAffirmativeOptions } from '../../../utils/data';

import toastService from '../../../services/toastService';

class FVIStructureAnomalyLocations extends Form {
	state = {
		data: { hasAnomalyLocations: 'yes', anomalyLocations: [] },
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		hasAnomalyLocations: Joi.string().min(2).required().label('Has Anomaly Locations'),
		anomalyLocations: Joi.any().when('hasAnomalyLocations', {
			is: 'yes',
			then: Joi.array().min(1).max(IMAGE_LIMITS.ANOMALY_LOCATIONS).required().label('Anomaly Locations'),
			otherwise: Joi.array().label('Anomaly Locations')
		}),
	};

	static propTypes = {
		initialAnomalyLocations: PropTypes.object,
		onAdd: PropTypes.func,
	};

	componentDidMount() {
		if (this.props.initialAnomalyLocations) {
			this.setState({ data: this.props.initialAnomalyLocations });
		}
	}

	doSubmit = (): void => {
		this.props.onAdd(this.state.data);
		toastService.success('Anomaly Location(s) Updated Successfully!');
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				{this.renderSelect({
					name: 'hasAnomalyLocations',
					placeholder: 'Does this structure have any Anomaly Locations?',
					label: 'Anomaly Locations:',
					options: getAffirmativeOptions(),
				})}

				<div className="divider my-4"></div>

				<Conditional isVisible={matchPhrases(this.state.data.hasAnomalyLocations, 'yes')}>
					{this.renderFileInput({
						max: IMAGE_LIMITS.ANOMALY_LOCATIONS,
						multiple: IMAGE_LIMITS.ANOMALY_LOCATIONS > 1,
						name: 'anomalyLocations',
						accept: 'image/*,application/pdf',
						label: 'Anomaly Locations',
						sublabel: 'Upload photos showing anomaly locations',
						types: getFileUploadTypes(),
						enforceImageCaptionUpdate: true,
					})}

					<div className="divider my-4"></div>
				</Conditional>

				<div className="d-flex justify-content-end">
					{this.renderButton('Save Anomaly Locations')}
				</div>
			</form>
		);
	}
}

export default FVIStructureAnomalyLocations;
